class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.duration = 500;

    this.mainDetailsToggle.querySelector('summary').addEventListener('click', e => {
      const detailsElement = e.currentTarget.parentNode;
      const isOpen = detailsElement.hasAttribute('open');
      if (isOpen) e.preventDefault();
      isOpen ? this.close() : this.open();
    })
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  close() {
    this.mainDetailsToggle.classList.add('no-after');
    setTimeout(() => {
      this.mainDetailsToggle.classList.remove('opening');
    }, 10);
    setTimeout(() => {
      this.mainDetailsToggle.removeAttribute('open');
    }, this.duration);
    document.body.classList.remove('overflow-hidden');
  }

  open() {
    setTimeout(() => {
      this.mainDetailsToggle.classList.remove('no-after');
      this.mainDetailsToggle.classList.add('opening');
    }, 10);
    document.body.classList.add('overflow-hidden');
  }
}

customElements.define('header-menu', HeaderMenu);
